import './App.css';
import Lamp from './fiberComponents/lamp';
import EducationTiles from './educationTiles';
import ProjectTiles from './projectTiles';
import { useProgress } from '@react-three/drei';
import SusLoader from './susLoader';


const biography1 = "Pierce Boyack is a dedicated and skilled software developer with a strong foundation in web development and system architecture. With extensive experience in technologies such as React, Django, and PostgreSQL, Pierce excels in creating robust and efficient solutions for diverse programming challenges. Known for meticulous attention to detail and a passion for clean, maintainable code, Pierce thrives in collaborative environments where innovative ideas are encouraged."
const biography2 = "In addition to technical expertise, Pierce possesses a solid understanding of software engineering principles, agile methodologies, and version control systems like Git. Pierce's proactive approach to problem-solving and ability to adapt to new technologies make them an asset to any development team. With a background in deploying applications on cloud platforms and utilizing modern development tools, Pierce is well-prepared to contribute effectively to projects ranging from backend infrastructure to user interface design. Passionate about continuous learning and keeping up on industry trends, Pierce is eager to leverage their skills and experience to drive impactful solutions in a dynamic work environment."

function SuspenseLoader() {  
  const {progress} = useProgress()
  return (
    <div className={`${progress === 100 ? "susBackgroundOff" : "susBackgroundOn"}`}>
      <div className='susLoader'>
        <SusLoader />
      </div>
    </div>
  )
}


function App() {
  return (
    <div className='App'>
      <div className='topHeader'>
        <div className='fiberLampWrapper'>
          <Lamp />       
        </div>
        <div className='avatarCardWrapper'>
          <div className='avatarBorder'>
            <div className='avatarContent'>
              <div className='avatarPicBox'>
                <div className='avatarPic'>
                  <img src='images/pfp2.jpg' alt='This is me' className='pfp'/>
                </div>
              </div>
              <div className='avatarDescription'>
                <text style={{fontSize: '24px'}}>Pierce Boyack</text>                
                <p>Bachelors in Computer Science<br/>University at Buffalo 2025</p>
                <div className='contacts'>
                  <a className="" href={"mailto:pierce.boyack@gmail.com"} rel="noopener noreferrer">
                    <img src={"images/email_50dp_FFFFFF.svg"} alt="email me"/>
                  </a>
                  <a className="" href={"https://github.com/PierceBoyack"} target="_blank" rel="noopener noreferrer">
                    <img className='contactResize' src={"images/github-mark-white.svg"} alt="see my github"/>
                  </a>
                </div>
                <div className="downloadBtnContainer">
                  <a className="downloadBtn" href="Pierce Boyack CV.pdf" target='_blank'>Download CV</a>
                </div>
                <div className='avatarInfo'>
                  Web Dev &middot; Software Engineer &middot; Data Analyst &middot; Front-End Engineer &middot; IT Specialist &middot; Cyber Security
                </div>
              </div>
            </div>
          </div>
        </div>
        <SuspenseLoader />
      </div>
      <div className='menuWrapper'>
        <div className='menuContainer'>
          <div className='menuHeader'>
            About Pierce
          </div>
          <div className='aboutWrapper'>
            <div className='biographyWrapper'>
              <div className='biography'>
                <div className='bioWords'>
                  <p>{biography1}</p>
                  <p>{biography2}</p>
                </div>
                <img src="images/pfp.jpg" alt='This is also me' className='aboutImage'/>
              </div>
            </div>
          </div>
          <div className='menuHeader'>
            Education and Certificates
          </div>
          <div className='educationTileContainer'>
            <EducationTiles />
          </div>
          <div className='menuHeader'>
            Featured Projects
          </div>
          <div className='projectTileContainer'>
            <ProjectTiles />
          </div>
        </div>
      </div>
      <div className='bottomFooter'></div>
    </div>
  );
}

export default App;
